import React from 'react';
import { FiX } from 'react-icons/fi';
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
  SidebarRoute,
} from './SidebarElements';

const Sidebar = ({ isOpen, toggle }) => {
  const linkProps = {
    onClick: toggle,
    smooth: true,
    duration: 500,
    spy: true,
    exact: 'true',
    offset: -72,
  };

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon>
          <FiX />
        </CloseIcon>
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to='services' {...linkProps}>
            Services
          </SidebarLink>
          <SidebarLink to='products' {...linkProps}>
            Products
          </SidebarLink>
          <SidebarLink to='about' {...linkProps}>
            About
          </SidebarLink>
          <SidebarLink to='contact' {...linkProps}>
            Contact
          </SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute to='contact' {...linkProps}>
            Get in touch
          </SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
